import api from "./axios";
import { UserInfo } from "./auth";

// Админ: управление аккаунтами (создание врачей-physician и правка)

export interface AdminCreateUserBody {
  email: string;
  password: string;
  role: string;
  name?: string;
  surname?: string;
  is_active?: boolean;
  is_verified?: boolean;
}

export async function adminCreateUser(body: AdminCreateUserBody): Promise<UserInfo> {
  const res = await api.post("/users/", body);
  return res.data;
}

export async function adminUpdateUser(
  userId: string,
  body: { name?: string; surname?: string; password?: string; is_active?: boolean }
): Promise<UserInfo> {
  const res = await api.patch(`/users/${userId}`, body);
  return res.data;
}
